import { Checkin, Guest } from '@/types/api/types'
import Repository from './repository'

export type PatchCheckinGuestArgs = {
  checkinId: number
  guest: Partial<Guest> & { id: number } // id is required, all other properties are optional
}

export type ReassignGuestArgs = {
  checkinId: number
  email: string
  dateOfBirth?: string
}

export default {
  postCheckin({
    email,
    bookingNo,
    propCode,
    primary,
    inviteUuid,
    dateOfBirth,
    deferCreation,
  }: {
    email?: string
    bookingNo: string
    propCode: string
    primary: 'true' | 'false'
    inviteUuid?: string
    dateOfBirth?: string
    // Ask "do we already know this guest?" without creating anything. The server answers 204
    // when it does not, so the Email screen can move on and the check-in gets created a screen
    // later, once a name exists. Older servers ignore the flag and create as they always did.
    // ENG-2921.
    deferCreation?: boolean
  }) {
    return Repository.post<Checkin | ''>(`/bookings/${bookingNo}/checkins`, {
      email,
      propCode,
      primary,
      inviteUuid,
      dateOfBirth,
      deferCreation,
    })
  },
  patchCheckin({ checkin, propCode, preCheckin }: { checkin: Partial<Checkin> & { id: number }; propCode: string; preCheckin?: boolean }) {
    return Repository.patch<Checkin>(`/checkins/${checkin.id}`, {
      checkin,
      propCode,
      ...(preCheckin ? { pre_checkin: true } : {}),
    })
  },
  patchGuest({
    checkinId,
    guest,
    propCode,
  }: PatchCheckinGuestArgs & { propCode: string }) {
    return Repository.patch<Checkin>(
      `/checkins/${checkinId}/guests/${guest.id}`,
      {
        guest,
        propCode,
      }
    )
  },
  reassignGuest({ checkinId, email, dateOfBirth }: ReassignGuestArgs) {
    return Repository.post<Checkin>(`/checkins/${checkinId}/reassign_guest`, {
      email,
      dateOfBirth,
    })
  },
}
